import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.btoa.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './style/index.scss';
import { utilCookies } from '@/util/cookies';
import createGroup from './components/createGroup';
import createFlow from './components/createFlow';
import { getWorkFlowList, delGroup, switchStatus } from '@/api/flow';
export default {
  components: {
    createGroup: createGroup,
    createFlow: createFlow
  },
  data: function data() {
    var str = utilCookies.getLanguage();
    return {
      lang: str,
      loadData: false,
      createVisible: false,
      createFlowVisible: false,
      dataForm: {
        keywords: ''
      },
      loading: false,
      tableData: [],
      groupsData: []
    };
  },
  created: function created() {
    this.handerGetData();
  },
  methods: {
    // 创建｜编辑分组
    handleCreate: function handleCreate(_ref) {
      var _this = this;
      var type = _ref.type,
        data = _ref.data;
      this.createVisible = true;
      this.$nextTick(function () {
        _this.$refs.create.init({
          type: type,
          data: data
        });
      });
    },
    // 创建审批流
    handleCreateFlow: function handleCreateFlow() {
      var _this2 = this;
      this.createFlowVisible = true;
      this.$nextTick(function () {
        _this2.$refs.createFlow.init();
      });
    },
    // 是否刷新页面
    handleUpdate: function handleUpdate(isUpdate) {
      this.createVisible = false;
      this.createFlowVisible = false;
      isUpdate && this.handerGetData();
    },
    // 删除分组
    handDelGroup: function handDelGroup(group) {
      var _this3 = this;
      if (group.workFlowList.length) return false;
      var $t = this.$t;
      this.$confirm($t('i18n.82bede28c3184db19c6afbf59ea8a958'), $t('229'), {
        confirmButtonText: $t('65'),
        cancelButtonText: $t('66'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              delGroup(group).then(function () {
                _this3.handerGetData();
                _this3.$message.success(_this3.$t('806'));
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    },
    // 编辑语言
    handleEditLang: function handleEditLang(row) {
      // 多语言配置仅支持自定义审批流
      if (row.type !== 2) return false;
      this.$router.push({
        path: '/approval/lang',
        query: {
          id: row.id
        }
      });
    },
    // 删除审批流
    handleDelFlow: function handleDelFlow(flow) {
      var _this4 = this;
      var $t = this.$t;
      this.$confirm($t('i18n.33fb3bc744cc4226bf97173df76b7f05'), $t('229'), {
        confirmButtonText: $t('65'),
        cancelButtonText: $t('66'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              switchStatus({
                id: flow.id,
                deleted: 2
              }).then(function () {
                _this4.handerGetData();
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })));
    },
    handleEditFlow: function handleEditFlow(flow) {
      this.$router.push({
        path: '/approval/editSetting',
        query: {
          fid: window.btoa(flow.id),
          type: 'edit'
        }
      });
    },
    // 删除审批流
    handleEnable: function handleEnable(flow) {
      var _this5 = this;
      // 0 启动。1停用 2 删除
      var $t = this.$t;
      if (!flow.deleted) {
        this.$confirm($t('i18n.87a931eda6a14e13903b6f8c93f093be'), $t('229'), {
          confirmButtonText: $t('139'),
          cancelButtonText: $t('66'),
          type: 'warning'
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                switchStatus({
                  id: flow.id,
                  deleted: 1
                }).then(function () {
                  _this5.handerGetData();
                });
              case 1:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        })));
      } else {
        switchStatus({
          id: flow.id,
          deleted: 0
        }).then(function () {
          _this5.handerGetData();
        });
      }
    },
    // 获取数据
    handerGetData: function handerGetData() {
      var _this6 = this;
      this.loadData = true;
      getWorkFlowList(this.dataForm).then(function (res) {
        _this6.groupsData = res.data.items;
      }).finally(function () {
        return _this6.loadData = false;
      });
    }
  }
};